import { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function LinkBreakIcon({
  className,
  color = "currentColor",
  size,
}: IconProps): ReactElement {
  return (
    <SvgIcon size={size} className={className}>
      <path
        d="M18 11.25L19.1512 10.1513C19.8343 9.44399 20.2123 8.49673 20.2038 7.5135C20.1952 6.53026 19.8008 5.58971 19.1056 4.89443C18.4103 4.19915 17.4697 3.80477 16.4865 3.79622C15.5033 3.78768 14.556 4.16566 13.8488 4.84875L12.75 6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12.75L4.84875 13.8488C4.16566 14.556 3.78768 15.5033 3.79622 16.4865C3.80477 17.4697 4.19915 18.4103 4.89443 19.1056C5.58971 19.8008 6.53026 20.1952 7.5135 20.2038C8.49673 20.2123 9.44399 19.8343 10.1512 19.1512L11.25 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 15H20.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 9H6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 18V20.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 3.75V6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
